import {
  logOut,
  selectCurrentUserObject,
  setUserType,
} from "../../store/auth/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, Form, Navigate } from "react-router-dom";
import { removeCookieToken, removeCookieValue } from "../../shared/helperFunction";

const Logout = (props) => {
  console.log("hererererere");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  dispatch(logOut());
  dispatch(setUserType(null));
  removeCookieToken("accessToken");
  removeCookieToken("refreshToken");
  navigate("/login", { state: { from: location }, replace: true });
  localStorage.clear();
};

export default Logout;
